export default "__VITE_ASSET__dG9x4B6B__"